import { useState } from 'react';
import { Pagination, Box, Drawer, ButtonGroup } from 'components/ui';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { FilterProvider, useFilter, initInspectionFilterValues } from 'contexts/filter';
import { usePaginate } from 'contexts/paginate';
import { DividerContainer } from 'components/styles_components/container';
import { useError } from 'contexts/error';
import FilterForm from 'components/inspection/filter_form';
import FilterTags from 'components/filter/tags';
import FilterButton from 'components/inspection/button/filter';
import CreateButton from 'components/inspection/button/create';
import InfoContainer from 'components/info_container';
import InspectionQuery from 'queries/inspection/index';
import Inspections from 'components/inspection/index';

const IndexContainer = ({
  placeId,
  inspectionSubjectId,
  overInspectionsLimit = undefined,
}) => {
  const { page, onPageChange } = usePaginate();
  const { inspectionsFilter, setInspectionsFilter } = useFilter();
  const [filterVisible, setFilterVisible] = useState(false);
  const [sortBy, setSortBy] = useState('due_date_desc');
  const setError = useError();
  const {
    data = { space: { overInspectionsLimit: false, adminRole: true }, inspections: { inspections: [] } },
    loading,
  } = useQuery(InspectionQuery, {
    variables: {
      ...inspectionsFilter,
      page: page,
      placeId: placeId,
      inspectionSubjectId: inspectionSubjectId,
      status: inspectionsFilter.status.length === 0 ? null : inspectionsFilter.status,
      sortBy: sortBy,
    },
    fetchPolicy: 'no-cache',
    onError: () => {
      setError('error.inspection.index');
    },
  });

  if (overInspectionsLimit === undefined) {
    overInspectionsLimit = data.space.overInspectionsLimit;
  }

  return (
    <FilterProvider>
      {filterVisible && (
        <Drawer
          anchor="right"
          open={filterVisible}
          onClose={() => {
            setFilterVisible(false);
          }}
        >
          <FilterForm
            initialValues={inspectionsFilter}
            defaultValues={initInspectionFilterValues}
            onClose={() => {
              setFilterVisible(false);
            }}
            onSubmit={(values) => {
              onPageChange(1);
              setFilterVisible(false);
              setInspectionsFilter(values);
            }}
          />
        </Drawer>
      )}

          <Box display="flex" justifyContent="flex-end">
            <ButtonGroup>
              <CreateButton
                placeId={placeId}
                inspectionSubjectId={inspectionSubjectId}
                overInspectionsLimit={overInspectionsLimit}
                adminRole={data.space.adminRole}
              />
              <FilterButton
                onClick={() => setFilterVisible(!filterVisible)}
                initInspectionFilterValues={initInspectionFilterValues}
                inspectionsFilter={inspectionsFilter}
              />
            </ButtonGroup>
          </Box>
          <FilterTags
            filterValues={inspectionsFilter}
            defaultValues={initInspectionFilterValues}
            onFilterChange={(newFilterValues) => {
              onPageChange(1);
              setInspectionsFilter(newFilterValues);
            }}
          />
          <InfoContainer visible={data.inspections.inspections.length === 0}>
            <FormattedMessage id="empty.inspections.title.short" />
          </InfoContainer>
          <Inspections
            loading={loading}
            inspections={data.inspections.inspections}
            sortBy={sortBy}
            onSortChange={setSortBy}
          />
          <Box display="flex" justifyContent="center">
            {data.inspections.inspectionsTotalPages > 1 && (
              <Pagination
                count={data.inspections.inspectionsTotalPages}
                page={page}
                onChange={(_e, nextPage) => {
                  onPageChange(nextPage);
                }}
              />
            )}
          </Box>

      <DividerContainer />
    </FilterProvider>
  );
};

export default IndexContainer;
